module.exports = __webpack_public_path__ + "img/logo-nutrimix-distribuidora.fbd5bfd5.svg";